import { useEffect } from 'react';
import { getAnalyticsConsent, onConsentChange } from '@/lib/analytics-consent';

const SCRIPT_ID = 'trustedtv-tag';
const SCRIPT_SRC = 'https://p3.trustedtv.com/022565a1-a0c6-4c14-b408-7473adab911d.js';

function loadTrustedTV(): void {
  if (document.getElementById(SCRIPT_ID)) return;
  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = SCRIPT_SRC;
  script.async = true;
  document.head.appendChild(script);
}

export default function TrustedTVTag() {
  useEffect(() => {
    if (getAnalyticsConsent()) {
      loadTrustedTV();
    }

    const cleanup = onConsentChange((consented) => {
      if (consented) {
        loadTrustedTV();
      }
    });

    return cleanup;
  }, []);

  return null;
}
